import { render, staticRenderFns } from "./LevelDetail.vue?vue&type=template&id=5ae1437a&"
import script from "./LevelDetail.vue?vue&type=script&lang=js&"
export * from "./LevelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports